import React, { useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import TextField from '@material-ui/core/TextField'

import Table from './Table'
import ServiceChargePanel from './ServiceChargePanel'

import { handleSaveCommercialTerms } from '../../actions/rfp'
import { showSnackbar } from '../../actions/snackbar'

import t from '../../utils/lang'

const styles = theme => ({
  root: {
    minHeight: 'calc(100vh - 330px)',
    paddingBottom: 48,
    position: 'relative',
  },
  panelHeader: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    flexBasis: '50%',
    flexShrink: 0,
    '@media screen and (max-width: 500px)': {
      fontSize: '0.8rem',
      flexBasis: '100%',
    }
  },
  panelDetails: {
    display: 'block'
  }
});

const CommercialTerms = props => {
  const { classes, i18n, proposalSubmitted, commercialTerms, space, parkings, fitoutContributionCommentData } = props;
  const [commercialTermsData, setCommercialTermsData] = useState(commercialTerms);
  const [fitoutContributionComment, setFitoutContributionComment] = useState(fitoutContributionCommentData);

  const handleUpdate = (lpId, section, row, value) => {
    setCommercialTermsData({
      ...(commercialTermsData ? commercialTermsData : []),
      [section]: {
        ...(commercialTermsData && commercialTermsData[section] ? commercialTermsData[section] : []),
        [lpId]: {
          ...(commercialTermsData && commercialTermsData[section] && commercialTermsData[section][lpId] ? commercialTermsData[section][lpId] : []),
          [row]: value ? Number(value) : null
        }
      }
    })
  }

  const handleSave = () => {
    const { rfpId, i18n, showSnackbar, onHandleSaveCommercialTerms } = props;
    const formData = new FormData()

    formData.append('rfpId', rfpId);
    formData.append('commercialTermsData', JSON.stringify(commercialTermsData));
    formData.append('fitoutContributionComment', fitoutContributionComment);

    onHandleSaveCommercialTerms(formData).then(
      showSnackbar({ message: i18n.snackbar.changesSaved })
    )
  }

  const sections = [
    { key: 'office', field: 'office', name: i18n.officeSpace },
    { key: 'retail', field: 'retail', name: i18n.retailSpace },
    { key: 'storage', field: 'storage', name: i18n.storageSpace },
    { key: 'underground', type: 'parking', field: 'parking_underground', name: i18n.parkingUnderground },
    { key: 'surface', type: 'parking', field: 'parking_surface', name: i18n.parkingSurface }
  ];

  return (
    <Fragment>
      <ServiceChargePanel />
      {sections.map((section, i) => {
        const isVisible = section.type === 'parking'
          ? parkings && Number(parkings[section.key])
          : space && (Number(space['net_' + section.key]) || Number(space['gross_' + section.key]));

        return isVisible
          ? <ExpansionPanel key={section.key}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.panelHeader}>{section.name}</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.panelDetails}>
                <Table
                  key={section.key}
                  section={section}
                  commercialTerms={commercialTermsData[section.field]}
                  handleUpdate={handleUpdate}
                />

                {section.key === 'office' && 
                  <TextField
                    id="fitoutContributionComment"
                    label={i18n.fitoutContributionComment}
                    fullWidth
                    value={fitoutContributionComment}
                    disabled={proposalSubmitted}
                    onChange={e => setFitoutContributionComment(e.target.value)}
                  />
                }

              </ExpansionPanelDetails>
              {proposalSubmitted ? '' : 
                <ExpansionPanelActions>
                  <Button size="small" color="primary" onClick={handleSave}>
                    {i18n.save}
                  </Button>
                </ExpansionPanelActions>
              }
            </ExpansionPanel>
          : ''
      })}
    </Fragment>
  )
}

function mapStateToProps({ rfpData }) {
  const { id, lang, statusId, commercialTerms, space, parkings, fitoutContributionComment } = rfpData

  return {
    rfpId: id,
    commercialTerms,
    i18n: t[lang],
    space,
    parkings,
    fitoutContributionCommentData: fitoutContributionComment,
    proposalSubmitted: statusId === 3
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onHandleSaveCommercialTerms: data => dispatch(handleSaveCommercialTerms(data)),
    showSnackbar: options => dispatch(showSnackbar(options))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CommercialTerms))


// WEBPACK FOOTER //
// ./src/components/CommercialTerms/CommercialTerms.js